export const home = {
  title: "Inicio",
  greeting: {
    morning: "Buenos días, {{name}}",
    afternoon: "Buenas tardes, {{name}}",
    evening: "Buenas noches, {{name}}",
  },
  attention: {
    title: "Requiere atención",
    description: "Denegaciones y bloqueos de las últimos 7 días.",
    allClear: "Nada pendiente. Todo en orden.",
    expiring_one: "{{name}} caduca {{when}} ({{issuer}})",
    expiring_other: "{{name}} caduca {{when}} ({{issuer}})",
    noValidVersion: "{{name}} no tiene ninguna versión válida y no firma",
    blockedSpike_one: "{{count}} petición bloqueada en {{host}}",
    blockedSpike_other: "{{count}} peticiones bloqueadas en {{host}}",
    blockedSpikePolicy_one:
      "{{count}} petición bloqueada en {{host}} por «{{policy}}»",
    blockedSpikePolicy_other:
      "{{count}} peticiones bloqueadas en {{host}} por «{{policy}}»",
    signatureSpike_one: "{{count}} firma denegada en {{host}}",
    signatureSpike_other: "{{count}} firmas denegadas en {{host}}",
    signatureSpikePolicy_one:
      "{{count}} firma denegada en {{host}} por «{{policy}}»",
    signatureSpikePolicy_other:
      "{{count}} firmas denegadas en {{host}} por «{{policy}}»",
    deniedSignatures_one: "{{count}} firma denegada",
    deniedSignatures_other: "{{count}} firmas denegadas",
    staleInvites_one:
      "{{count}} invitación sin aceptar desde hace más de {{days}} días",
    staleInvites_other:
      "{{count}} invitaciones sin aceptar desde hace más de {{days}} días",
    replace: "Sustituir",
    see: "Ver",
  },
  steps: {
    title: "Primeros pasos",
    description: "Desaparece cuando lo hayas completado todo.",
    done: "Hecho:",
    pending: "Pendiente:",
    items: {
      certificate: "Añade un certificado",
      invite: "Invita a tu equipo",
      policy: "Crea una política",
      mac: "Instala la app de Mac",
    },
  },
  recent: {
    title: "Últimos 7 días",
    signatures: "Firmas",
    denied: "Denegadas",
    activePeople: "Personas activas",
  },
};
